import type { LDClient } from 'launchdarkly-js-client-sdk';

export function createLaunchDarklyHelpers(ldClient: LDClient) {
  function getFlag(key: string, defaultValue: boolean) {
    return ldClient?.variation(key, defaultValue);
  }
  function onFlagChange(key: string, callback: (value: any) => void) {
    ldClient?.on(`change:${key}`, callback);
  }
  return { getFlag, ldClient, onFlagChange };
}
